var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var $ = require("./lib/qsa");
var dot = require("./lib/dot");
var templateSource = require("./_ai2html-map.html");
var template = dot.compile(templateSource);

var navTemplateSource = require("./_nav-content.html");
var navTemplate = dot.compile(navTemplateSource);

async function init(pymChild) {
  if (window.location.hostname == "apps.npr.org") {
    var request = await fetch("https://apps.npr.org/dailygraphics/data/sheets/hip-hop-50-20230627.json");
    var copy = await request.json();

    // map stuff
    var data = copy.labels;
    var content = template(data);
    var graphicEl = $.one("#map");

    if (graphicEl) {
      graphicEl.innerHTML = content;
    };

    // nav stuff
    var navData = copy; 
    var navContent = navTemplate(navData); 
    var navEl = $.one("#nav");

    if (navEl) {
      navEl.innerHTML = navContent; 
    };
  }
  pymChild.sendHeight();
}

var onWindowLoaded = function() {

  pym.then(child => {

      init(child);
      child.sendHeight();

      window.addEventListener("resize", () => child.sendHeight());
  });
}

// wait for images to load
window.onload = onWindowLoaded;